import styled from "styled-components";

export const WorkshopWrapper = styled.div`
    padding-top: 5.80rem;
    background-color: var(--bgSecondary);
    .pg-title {
        background-color: var(--white);
        border-bottom: 1px solid var(--border);
    }
    .tutorial-vid {
        max-width: 1050px;
        max-height: 520px;
    }
    .tutorial-vid {
        min-width: 100%;
    }
    body.rtl & {
        .ratio > * {
            left: unset;
            right: 0;
        }
    }
    .content-box {
        background-color: var(--white);
        border-radius: 12px;
    }
    
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

export const BaseButton = styled.button`
  min-width: 120px;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.25s ease;
  outline: none;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const NextButton = styled(BaseButton)`
  background-color: var(--themeColor);
  color: var(--white);

  &:hover {
    background-color: #1e40af;
  }

  &:disabled {
    background-color: var(--themeColor);
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const PreviousButton = styled(BaseButton)`
  background-color: var(--bgSecondary);
  color: var(--text);

  &:hover {
    background-color: #d1d5db;
  }

  &:disabled {
    background-color: var(--bgSecondary);
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SubmitButton = styled(BaseButton)`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: var(--themeColor);
  color: var(--white);

  &:hover {
    background-color: #035FCC;
  }
  
  &:disabled {
    background-color: var(--themeColor);
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const WorkshopParticipantWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .logo-container {
    padding: 29.5px;
    border-right: 1px solid var(--border);
    border-left: 1px solid var(--border);
    min-width: 270px;

    @media (max-width: 992px) {
      min-width: unset;
      max-width: 90%;
      border-left: none;   /* remove left border */
      border-right: none;  /* remove right border */
      padding: 20px;       /* optional: reduce padding on smaller screens */
    }
  }

  .participant_header {
    border-bottom: 1px solid var(--border);
  }
`;


export const FormWrapper = styled.div`
  width: 100%;
  max-width: 768px;   /* Large screens */
  min-width: 700px;   /* Minimum on desktop */
  margin: 60px auto 0;
  padding: 32px;
  border-radius: 8px;
  background: #ffffff;

  /* Tablets */
  @media (max-width: 992px) {
    min-width: unset;
    max-width: 90%;
  }

  /* Mobile */
  @media (max-width: 576px) {
    max-width: 100%;
    padding: 20px;
    border-radius: 0;
  }
`;


export const FormTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: center;
`;

export const FormGroup = styled.div`
  margin-bottom: 16px;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
  display: block;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  color: var(--text);
  background: #ffffff;

  &:focus {
    border-color: #2563eb;
  }
`;

export const ErrorText = styled.p`
  margin-top: 4px;
  font-size: 12px;
  color: #dc2626;
`;


